import { render } from "./CRMDepartmentHigh.vue?vue&type=template&id=35569f98&scoped=true"
import script from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"
export * from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"

import "./CRMDepartmentHigh.vue?vue&type=style&index=0&id=35569f98&scoped=true&lang=css"
import "./CRMDepartmentHigh.vue?vue&type=style&index=1&id=35569f98&lang=css"
script.render = render
script.__scopeId = "data-v-35569f98"

export default script